import axios from 'axios';

// API для ML-моделей
const mlApi = axios.create({
  baseURL: process.env.VUE_APP_ML_API_URL || 'https://apiml.labhub.online',
  headers: {
    'Content-Type': 'application/json'
  }
});

// The user's key is kept in memory, never embedded in the public bundle or URL.
function setMlApiKey(value) {
  const key = value.trim().replace(/^Bearer\s+/i, '');
  if (key) mlApi.defaults.headers.common.Authorization = `Bearer ${key}`;
  else delete mlApi.defaults.headers.common.Authorization;
}

// Основной API
const mainApi = axios.create({
  baseURL: process.env.VUE_APP_MAIN_API_URL || 'https://api.labhub.online/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

export { mlApi, mainApi, setMlApiKey };
export default mainApi; // для обратной совместимости

// Public demo goes through the protected server gateway; no service key in the browser.
export const promoApi = axios.create({baseURL: '/promo-api', timeout: 25000, headers: {'Content-Type': 'application/json'}});
